(function () {
  const blockRosterForm = 'form.js-block-roster';
  const blockRosterBtn = '.js-block-roster-btn';
  const bodyClassTeams = '.controller-league_settings-players-teams';
  const warnTeamsCreationClass = '.js-warn-teams-creation';

  const blockRosterApp = function () {
    const preventFormSubmit = (e) => {
      if ($(bodyClassTeams).length > 0) return true;

      window.stopEvent(e);

      var link = $('<a>').attr('href', `/leagues/${gon.league_id}/replaces/new`)
                         .attr('data-turbolinks', 'false')
                         .text('Replace Player / Add team');
      window.swalWithBootstrapButtons.fire({
        title: 'Oops',
        html: `Team changes are disabled because there are calculated rounds. \
               If you wish to make changes please use the ${link[0].outerHTML} utility.`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Ok',
      });
    };

    const warnTeamsCreation = () => {
      window.swalWithBootstrapButtons.fire({
        title: 'Warning',
        html: "If you add teams, the system will recreate your pairings, which will change the current matchups. Are you sure you want to continue?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No, cancel',
        reverseButtons: true,
      }).then(result => {
        if (result.isConfirmed) return false;

        $("#manually-form-modal").modal('hide');
      });
    }

    const init = function() {
      $(document).on('submit', blockRosterForm, preventFormSubmit)
      $(document).on('click', blockRosterBtn, preventFormSubmit)
      $(document).on('click', warnTeamsCreationClass, warnTeamsCreation)
    }

    $(document).on('turbolinks:load', init);
  };

  if (typeof window !== "undefined") {
    window.blockRosterApp = blockRosterApp();
  }

  return blockRosterApp;
})();
